import YouTube from "react-youtube";
import YouTubeShort from "./YouTubeShort";

export const Depositions = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const youtubeLinks = [
    "https://www.youtube.com/shorts/cX-aWWM6zG4",
    "https://www.youtube.com/shorts/ipvkE-IyGag",
    "https://www.youtube.com/watch?v=Y4x_AkrzB1k&feature=youtu.be",
    "https://www.youtube.com/watch?v=ROgJyvEWcIA",
    "https://www.youtube.com/watch?v=WvBEfH0nnVA",
    "https://www.youtube.com/watch?v=41jA_kSVFAo",
    "https://www.youtube.com/shorts/td0_kh1He0w",
    "https://www.youtube.com/shorts/9YZcBgBsOOc",
  ];

  return (
    <div className="bg-gradient-to-br from-slate-900 via-brand-blue to-slate-800 text-white overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-brand-blue/20 via-transparent to-brand-yellow/20 animate-pulse"></div>
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-brand-yellow/10 rounded-full blur-3xl animate-bounce"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-brand-blue/10 rounded-full blur-3xl animate-pulse"></div>
        </div>
        <div className="relative z-10 text-center max-w-5xl px-4 py-16 md:py-20 animate-fadeInUp">
          <h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black font-montserrat mb-4 md:mb-6 bg-gradient-to-r from-white via-brand-yellow to-white bg-clip-text text-transparent animate-pulse"
            style={{ lineHeight: "1.2", paddingTop: "0.25rem" }}
          >
            DEPOIMENTOS
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-light font-roboto mb-6 md:mb-8 max-w-3xl mx-auto leading-relaxed px-2">
            Histórias reais de recuperação, esperança e transformação de vidas.
          </p>

          {/* Scroll Indicator */}
          <div className="animate-bounce-gentle mb-8">
            <svg
              className="w-8 h-8 text-white/70 hover:text-white transition-colors duration-300 mx-auto"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              />
            </svg>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-white text-brand-blue">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold font-montserrat mb-6 bg-gradient-to-r from-brand-blue to-brand-yellow bg-clip-text text-transparent">
              Vozes da Recuperação
            </h2>
            <p className="text-xl font-roboto text-gray-600 max-w-4xl mx-auto leading-relaxed">
              Conheça as histórias inspiradoras de pessoas que encontraram
              força, esperança e uma nova vida através da PATRE.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {youtubeLinks.map((link, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-white to-gray-50 p-6 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 hover:scale-105 border border-gray-100"
              >
                <div className="aspect-video rounded-2xl overflow-hidden mb-4 bg-gray-100 flex justify-center items-center">
                  {isShort(link) ? (
                    <YouTubeShort videoId={getShortId(link)} />
                  ) : (
                    <div className="video-wrapper flex justify-center items-center">
                      <YouTube
                        videoId={getVideoId(link)}
                        opts={{
                          width: "100%",
                          height: "100%",
                          playerVars: { modestbranding: 1, rel: 0 },
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="text-center">
                  <h3 className="text-lg font-bold font-montserrat text-brand-blue mb-2">
                    Depoimento {index + 1}
                  </h3>
                  <p className="text-sm font-roboto text-gray-600">
                    História real de transformação
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-20 bg-gradient-to-r from-brand-blue to-brand-yellow text-white">
        <div className="max-w-5xl mx-auto text-center px-4">
          <h2 className="text-5xl font-bold font-montserrat mb-8 animate-pulse">
            Sua História Também Pode Ser Contada
          </h2>
          <p className="text-2xl font-roboto mb-12 max-w-3xl mx-auto leading-relaxed">
            Se você foi tocado pela nossa comunidade ou conhece alguém que
            precisa de ajuda, entre em contato. Cada história importa.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <a
              href="https://wa.me/5554996998885?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20Comunidade%20Terap%C3%AAutica%20Cristo%20Rei%20PATRE%20e%20gostaria%20de%20saber%20mais%20sobre%20o%20tratamento."
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-brand-blue font-bold font-montserrat py-5 px-12 rounded-full text-xl uppercase tracking-wider shadow-2xl hover:shadow-white/50 transform hover:scale-110 transition-all duration-500"
            >
              Fale Conosco
            </a>
            <a
              href="#tratamento"
              onClick={() => scrollToSection("tratamento")}
              className="border-2 border-white text-white font-bold font-montserrat py-5 px-12 rounded-full text-xl uppercase tracking-wider hover:bg-white hover:text-brand-blue transition-all duration-500"
            >
              Tratamento
            </a>
          </div>
        </div>
      </section>

      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="hidden md:fixed bottom-8 right-8 bg-gradient-to-r from-brand-blue to-brand-yellow text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-500 z-50 group"
        aria-label="Voltar ao topo"
      >
        <svg
          className="w-6 h-6 transform group-hover:-translate-y-1 transition-transform duration-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
      </button>
    </div>
  );
};

function getVideoId(link: any) {
  const url = new URL(link);
  return url.searchParams.get("v") ?? "";
}

function getShortId(link: any) {
  const url = new URL(link);
  return url.pathname.split("/").pop() ?? "";
}

function isShort(link: any) {
  return link.includes("youtube.com/shorts/");
}
